
angular.module('bmsApp.directives')
	.directive('customerFeedback', [
		'notify',
		'FeedbackSvc',
		'ConfigService', function (
			notify,
			FeedbackSvc,
			ConfigService) {
			return {
				restrict: 'E',
				scope: {
					objectType: '=',
					objectId: '='
				},
				replace: true,
				templateUrl: 'ng/feedback/directives/CustomerFeedback.html',
				link: function (scope, element, attrs) {
					scope.$watchGroup(['objectType', 'objectId'], function(newValues, oldValues, scope) {
						scope.$broadcast('showFeedback');
					});
				},
				controller: function ($scope) {
					$scope.config = ConfigService.config;

					$scope.$on('showFeedback', function() {
						var params = {
							id: $scope.objectId,
							objectType: $scope.objectType,
							filter: {
								submitted: true,
							}
						};
						FeedbackSvc.index(params).then(function(response) {
							$scope.feedbackResponses = response.data.feedback_response_collection;
						});

					});
				}
			};
		}]);
